import { render, staticRenderFns } from "./ConsignmentNote.vue?vue&type=template&id=32c411d2&scoped=true&"
import script from "./ConsignmentNote.vue?vue&type=script&lang=js&"
export * from "./ConsignmentNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c411d2",
  null
  
)

export default component.exports